var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87376 4.30713C9.11769 0.694541 13.9059 -1.45444 16.7275 1.1496C16.7275 1.1496 17.9879 0.829509 19.0967 0.189335C18.772 1.01937 18.1513 1.7273 17.3328 2.20087C17.3328 2.20087 18.8442 2.01823 19.5 1.65232C19.5 1.65232 18.8442 2.88686 17.6351 3.34439C18.2901 11.6208 8.46261 16.6506 0.5 12.5353C0.5 12.5353 4.43115 12.721 6.09546 10.9807C6.09546 10.9807 3.67645 11.1633 2.4666 8.5116C2.4666 8.5116 3.37416 8.83169 4.28103 8.41997C4.28103 8.41997 1.45874 8.00825 1.21035 4.94483C1.21035 4.94483 2.11723 5.585 3.1251 5.35593C3.1251 5.35593 0.000504911 3.66448 1.76444 0.600434C1.76444 0.600434 5.09101 4.439 9.87854 4.30465L9.87376 4.30713Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5c4bd65dec6a8afd98004db2374ad45a.svg";
export { ForwardRef as ReactComponent };